class UpdateStatus {

    constructor() {
      this.form = document.querySelector('.js-application-status')
    }
  
    init() {
      this.events()
    }
  
    events() {

		if ( this.form ) {
			
			this.form.addEventListener('submit', ( ev ) => {
				ev.preventDefault()

				if (confirm('Confirm below to update status and send email')) {

					this.updateStatus( ev.target.dataset.postId )
					.then( ( response ) => {
						console.log( response.ok )
						window.location.reload();
					})

				}
			})

		}
  
    }
  
    async updateStatus( postId ) {

		const form = new FormData();
		form.append('action', 'update_status');
		form.append('postId', postId);
		form.append('status', this.form.elements['status'].value);
		form.append('nonce', main_js.nonce);

		const response = await fetch(main_js.ajaxurl, {
			method: 'POST',
			body: form,
			credentials: 'same-origin',
		});

		return response

    }

  }
  
  export default UpdateStatus
  